import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Attribute} from '../../../_models/attribute.model';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() waveFormUri: string;
  @Input() uri: string;
  @Output() played = new EventEmitter<boolean>();
  private player: any;
  private firefoxTimer: any = null;
  private playerTimer: any = null;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.playerTimer = setTimeout(() => {
      this.player = document.getElementById('native-audio-player');
      const self = this;
      this.player.onplay = function () {
        self.played.emit(true);
      };
    }, 1250);

    if (window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      this.firefoxTimer = setTimeout(() => {
        const div = document.getElementById('wave-form-div');
        if (div) {
          div.classList.toggle('waveformfirefox');
        }
      }, 1300);
    }
  }

  ngOnDestroy(): void {
    if (this.playerTimer) {
      clearTimeout(this.playerTimer);
      this.playerTimer = null;
      console.log('Cleared - AudioPlayer Timer');
    }
    if (this.firefoxTimer) {
      clearTimeout(this.firefoxTimer);
      this.firefoxTimer = null;
      console.log('Cleared - Firefox Timer');
    }
  }

}
